
/* User defined models */
export class Contact {
  phoneNumber: string;
  faxNumber: string;

  constructor(
    phoneNumber: string,
    faxNumber: string
  ) {
    this.phoneNumber = phoneNumber;
    this.faxNumber = faxNumber;
  }
}